export const AUDIT_PAGE_SIZE = 50;

export function auditPageRange(page: number): { from: number; to: number } {
  const safePage = Number.isSafeInteger(page) && page >= 0 ? page : 0;
  const from = safePage * AUDIT_PAGE_SIZE;
  return { from, to: from + AUDIT_PAGE_SIZE - 1 };
}

export function auditPageCount(total: number): number {
  return Math.max(1, Math.ceil(Math.max(0, total) / AUDIT_PAGE_SIZE));
}
